class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").updateQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this;
    this.cartItemConatiner = this.querySelector("#cart-notification-product");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener("keydown", (event) => {
      if (!this.classList.contains("active")) return;
      if (event.key === "Escape") {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== "Tab") return;
      const controls = this.focusableControls();
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (!first) {
        event.preventDefault();
        this.focus({ preventScroll: true });
      } else if (event.shiftKey && (document.activeElement === first || document.activeElement === this)) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    });

    this.querySelector(
      'button[type="button"].cart-notification__close'
    ).addEventListener("click", this.close.bind(this));

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target.closest("quantity-input")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  focusableControls() {
    return getFocusableElements(this).filter((element) =>
      !element.closest('[hidden], [inert]') &&
      element.getClientRects().length &&
      getComputedStyle(element).visibility !== "hidden"
    );
  }

  cancelOpeningFocus() {
    this.openingFocusCleanup?.();
  }

  scheduleOpeningFocus() {
    this.cancelOpeningFocus();
    let cancelled = false;
    const focusDeadline = Date.now() + 2000;
    let firstFrame;
    let secondFrame;
    let fallbackTimer;
    const cancel = () => {
      if (cancelled) return;
      cancelled = true;
      cancelAnimationFrame(firstFrame);
      cancelAnimationFrame(secondFrame);
      clearTimeout(fallbackTimer);
      this.removeEventListener('transitionend', onTransition);
      this.removeEventListener('transitioncancel', onTransition);
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('pointerdown', onInteraction, true);
      document.removeEventListener('keydown', onKeydown, true);
      if (this.openingFocusCleanup === cancel) this.openingFocusCleanup = null;
    };
    const canMoveFocus = () => {
      const current = document.activeElement;
      return current === this.activeElement || current === document.body || current === document.documentElement;
    };
    const focusWhenReady = () => {
      if (cancelled) return;
      if (Date.now() > focusDeadline) { cancel(); return; }
      if (!this.isConnected || this.inert || !this.classList.contains('active') || this.contains(document.activeElement) || !canMoveFocus()) {
        cancel();
        return;
      }
      const target = this.querySelector('.cart-notification__close') || this;
      if (!target.getClientRects().length || ['hidden', 'collapse'].includes(getComputedStyle(target).visibility)) return;
      if (typeof document.elementFromPoint === 'function') {
        const rect = target.getBoundingClientRect();
        const topElement = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
        if (!topElement || !target.contains(topElement)) return;
      }
      target.focus({ preventScroll: true });
      if (this.contains(document.activeElement)) cancel();
    };
    const onTransition = (event) => { if (event.target === this) focusWhenReady(); };
    const onFocusIn = () => { if (this.contains(document.activeElement) || !canMoveFocus()) cancel(); };
    const onInteraction = () => cancel();
    const onKeydown = (event) => {
      if (!canMoveFocus() || this.contains(document.activeElement)) { cancel(); return; }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
      } else if (event.key === 'Tab') {
        event.preventDefault();
        focusWhenReady();
      } else {
        cancel();
      }
    };
    this.openingFocusCleanup = cancel;
    this.addEventListener('transitionend', onTransition);
    this.addEventListener('transitioncancel', onTransition);
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('pointerdown', onInteraction, true);
    document.addEventListener('keydown', onKeydown, true);
    const style = getComputedStyle(this);
    const milliseconds = (value) => {
      const amount = Number.parseFloat(value) || 0;
      return value.trim().endsWith('ms') ? amount : amount * 1000;
    };
    const durations = (style.transitionDuration || '0s').split(',').map(milliseconds);
    const delays = (style.transitionDelay || '0s').split(',').map(milliseconds);
    const transitionTime = Math.max(0, ...durations.map((duration, index) => duration + delays[index % delays.length]));
    const retry = () => {
      focusWhenReady();
      if (cancelled) return;
      const remaining = focusDeadline - Date.now();
      if (remaining <= 0) { cancel(); return; }
      fallbackTimer = setTimeout(retry, Math.min(50, remaining));
    };
    fallbackTimer = setTimeout(retry, Math.min(transitionTime + 80, 2000));
    firstFrame = requestAnimationFrame(() => {
      focusWhenReady();
      if (!cancelled) secondFrame = requestAnimationFrame(() => focusWhenReady());
    });
  }

  disconnectedCallback() {
    this.cancelOpeningFocus();
  }

  open() {
    if (!this.classList.contains("active") && !this.activeElement) {
      this.setActiveElement(document.activeElement);
    }
    this.inert = false;
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");
    this.scheduleOpeningFocus();
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.cancelOpeningFocus();
    if (!this.classList.contains("active")) return;
    this.notification.classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");
    document.body.removeEventListener("click", this.onBodyClick);
    const opener = this.activeElement;
    this.activeElement = null;
    const fallback = document.querySelector('.header__actions_btn--cart');
    const target = opener?.isConnected && opener.getClientRects().length ? opener : fallback;
    target?.focus({ preventScroll: true });
    this.inert = true;
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id]
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    document
      .querySelector(".cart_action_drawer_overlay")
      .classList.add("active");
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.renderContents(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {})
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("open-minicart") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
  }

  onClickMiniCart() {
    this.notification.setActiveElement(this.cartButton);
    this.notification.open();
  }

  miniCartClose() {
    this.notification.close();
  }
}
customElements.define("open-minicart", OpenMiniCart);
